import { render, staticRenderFns } from "./UpVote.vue?vue&type=template&id=76196071"
import script from "./UpVote.vue?vue&type=script&lang=js"
export * from "./UpVote.vue?vue&type=script&lang=js"
import style0 from "./UpVote.vue?vue&type=style&index=0&id=76196071&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports